<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.ATTACHED_DOCUMENT_EXISTS
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-10">
        <div class="list-container spacing-mb-30">
          <table
            class="table has-text-black"
            :title="General.TEXTS.FILE_LIST"
            :aria-describedby="General.TEXTS.FILE_LIST"
          >
            <thead>
              <tr>
                <th class="has-text-grey-dark">
                  {{ General.PROCESS_DOCUMENTS }}
                </th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="doc in processFiles" :key="doc.id">
                <td>
                  <a
                    class="is-underlined has-text-color-7 is-clickable"
                    @click="downloadFile(doc.id)"
                  >
                    {{ doc.attachment_name }}
                  </a>
                </td>
                <td>
                  <SubscriptionHistoryOnlyView
                    :signHistory="doc.sign_history"
                    :processId="processId"
                    :tooltipPosition="isMobile ? 'is-right' : 'is-top'"
                    class="is-flex"
                  />
                </td>
              </tr>
              <tr v-if="!processFiles.length">
                <td colspan="2">
                  <div
                    class="has-text-color-7 is-flex is-justify-content-center pt-15"
                  >
                    <b-icon icon="text-search" class="mr-5" />
                    {{ General.MESSAGES.NO_RESULT_FOUND.toUpperCase() }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="table has-text-black"
            :title="General.TEXTS.FILE_LIST"
            :aria-describedby="General.TEXTS.FILE_LIST"
          >
            <thead>
              <tr>
                <th class="has-text-grey-dark">
                  {{ General.EDITABLE_FILES }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="doc in editablesFiles" :key="doc.id">
                <td>
                  <a
                    class="is-underlined has-text-color-7 is-clickable"
                    @click="downloadFile(doc.id)"
                  >
                    {{ doc.attachment_name }}
                  </a>
                </td>
              </tr>
              <tr v-if="!editablesFiles.length">
                <td
                  class="has-text-color-7 is-flex is-justify-content-center pt-15"
                >
                  <b-icon icon="text-search" class="mr-5" />
                  {{ General.MESSAGES.NO_RESULT_FOUND.toUpperCase() }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SubscriptionHistoryOnlyView from "@/components/SubscriptionHistoryOnlyView";
import { mapActions, mapGetters } from "vuex";
import { General } from "@/utils/constants";

export default {
  name: "ModalShareDetail",
  components: {
    SubscriptionHistoryOnlyView
  },
  props: {
    processFileRequestedId: {
      type: String,
      required: true
    },
    processId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      General
    };
  },

  computed: {
    ...mapGetters({
      listDoc: "getListFileDraft",
      isMobile: "isMobile"
    }),
    editablesFiles() {
      return this.listDoc(this.processFileRequestedId).filter(
        file => file.editable
      );
    },
    processFiles() {
      return this.listDoc(this.processFileRequestedId).filter(
        file => !file.editable
      );
    }
  },

  methods: {
    ...mapActions({
      requestFile: "requestDataProcessFile"
    }),
    close() {
      this.$parent.close();
    },
    async downloadFile(documentId) {
      const result = await this.requestFile({
        fileIds: [{ process_file_id: documentId }],
        processId: this.processId,
        printer_version: true
      });
      if (result) {
        const [{ url_file }] = result;
        window.open(url_file, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  width: 600px;
  max-width: 75vw;
  min-height: 300px;
  max-height: 75vh;
  background-color: $color-1;
}
.list-container {
  overflow: auto;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.table {
  width: 100%;
}

table tbody tr:hover {
  background-color: transparent !important;
}
</style>
